import React from 'react'
import { Card, CardHeader, CardBody, Alert, CardFooter, } from 'reactstrap'
import { BeatLoader } from 'react-spinners'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { CSVList } from './'

/**
 * Provides the view for downloading CSVs of 
 * usernames generated using the bulk upload
 * tool.
 * @param {object} props 
 */
function UsernameCSVsManage ({
  assessmentName,
  csvData,
  error,
  linkToUpload,
  loading,
  loadingComplete,
  schoolName,
  year,
}) {
  if (!loadingComplete || error) {
    return (
      <Card>
        <CardBody>
          <BeatLoader loading={loading} color={'#00C1AB'}/>
          {error && <Alert color='danger'>Error loading.</Alert>}
        </CardBody>
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader>
        <h2>Username Upload History</h2>
        <h5>{schoolName}</h5>
        <h5>{`${assessmentName}, ${year}`}</h5>
      </CardHeader>
      <CardBody>
        <CSVList 
          csvData={csvData}
          loadingComplete={loadingComplete}
          schoolName={schoolName}
        />
      </CardBody>
      <CardFooter>
        <Link to={linkToUpload}>{'< Back to Upload CSV'}</Link>
      </CardFooter>
    </Card>
  )
}

const { string, array, bool } = PropTypes
UsernameCSVsManage.propTypes = {
  assessmentName: string,
  csvData: array,
  error: bool.isRequired,
  linkToUpload: string,
  loading: bool.isRequired,
  loadingComplete: bool.isRequired,
  schoolName: string,
  year: string,
}

export default UsernameCSVsManage


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/UsernameCSVsManage.js